import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Hero() {
  return <section id="hero" className="glow-bg-blue pt-20 pb-[60px] md:pt-[80px] md:pb-[60px] text-center relative z-10 overflow-hidden" data-id="element-138">
      <div className="max-w-[800px] mx-auto px-5 relative z-10" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-1.5 bg-transparent border-[1.5px] border-brand-blue text-brand-blue text-xs font-semibold py-1.5 px-3.5 rounded-full tracking-[0.5px] mb-6" data-id="element-140">
          ⚡ Solo para estudiantes universitarios
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-[clamp(28px,5vw,46px)] font-black leading-[1.2] mb-6" data-id="element-141">
          ¿Estudiás 6 horas para un parcial y seguís sacando un 6?
          <br className="hidden md:block" data-id="element-142" />
          <span className="text-brand-blue" data-id="element-143">
            O peor: ¿el parcial es en 3 días y todavía no arrancaste?
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-[clamp(16px,2.5vw,19px)] text-brand-gray max-w-[600px] mx-auto mb-8 leading-[1.7]" data-id="element-144">
          Este sistema de IA hace en 40 minutos lo que vos tardás 6 horas en
          hacer solo. Resúmenes, mapas conceptuales, simulacros de parcial y
          plan de estudio —{' '}
          <strong className="text-white font-semibold" data-id="element-145">
            al toque, sin drama, para cualquier materia.
          </strong>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="flex justify-center mb-4" data-id="element-146">
          <Button href="https://librofy-store.myshopify.com/cart/47909760106717:1" data-id="element-147">
            → QUIERO EL SISTEMA AHORA
          </Button>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-[12px] md:text-[13px] text-brand-gray text-center mt-3 flex items-center justify-center flex-wrap gap-x-2 gap-y-1" data-id="element-148">
          <span data-id="element-149">🔒 Pago seguro</span>
          <span className="hidden sm:inline" data-id="element-150">·</span>
          <span data-id="element-151">⚡ Acceso en 5 min</span>
          <span className="hidden sm:inline" data-id="element-152">·</span>
          <span data-id="element-153">🛡️ Garantía 7 días</span>
          <span className="hidden sm:inline" data-id="element-154">·</span>
          <span data-id="element-155">💳 Mercado Pago</span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-[700px] mx-auto" data-id="element-156">
          <div className="flex flex-col items-center p-4 bg-navy-2 border border-brand-blue-dark rounded-xl" data-id="element-157">
            <span className="text-2xl font-black text-brand-gold mb-1" data-id="element-158">
              +200
            </span>
            <span className="text-[12px] text-brand-gray leading-tight" data-id="element-159">
              estudiantes
              <br data-id="element-160" />
              este cuatri
            </span>
          </div>
          <div className="flex flex-col items-center p-4 bg-navy-2 border border-brand-blue-dark rounded-xl" data-id="element-161">
            <span className="text-2xl font-black text-white mb-1" data-id="element-162">40 min</span>
            <span className="text-[12px] text-brand-gray leading-tight" data-id="element-163">
              vs 6 horas
              <br data-id="element-164" />
              de estudio
            </span>
          </div>
          <div className="flex flex-col items-center p-4 bg-navy-2 border border-brand-blue-dark rounded-xl" data-id="element-165">
            <span className="text-2xl font-black text-brand-gold mb-1" data-id="element-166">
              4.9/5
            </span>
            <span className="text-[12px] text-brand-gray leading-tight" data-id="element-167">
              valoración
              <br data-id="element-168" />⭐
            </span>
          </div>
          <div className="flex flex-col items-center p-4 bg-navy-2 border border-brand-blue-dark rounded-xl" data-id="element-169">
            <span className="text-2xl font-black text-white mb-1" data-id="element-170">7 días</span>
            <span className="text-[12px] text-brand-gray leading-tight" data-id="element-171">
              garantía
              <br data-id="element-172" />
              sin drama
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}